import { Fragment, useState, useCallback } from 'react';
import { useCookies } from "react-cookie";

import { Text } from '../../FormControls/Text';
import { Stack } from '../../FormControls/Stack';
import { Box } from '../../FormControls/Box';
import { Input } from '../../FormControls/Input';

import { useDispatch, useSelector } from 'react-redux'
import { setPhone, generateContract, signContract, updateUserPhoneNumber } from '../../../../main/slices/userSlice';
import { createSelector } from '@reduxjs/toolkit';
import { ScreenControl } from '../ScreenControl';
import { useEffect } from 'react';
import { Fingerprint } from '@mui/icons-material';

const NumberComponent = ({ number, ext, numberChange, extensionChange }) => {

    return (
        <Fragment>
            <Box>
                <Text classes={["subtitle"]}> Te enviaremos un código de verificación </Text>
                <Text classes={["title", "left"]}> Ingresa tu numero </Text>

                <Stack flex={{ justifyContent: "space-between" }}>
                    <Input type="number" classes={["width20"]} attributes={{ min: 0, value: ext || "" }} placeHolder="000" onChange={extensionChange} />
                    <Input type="number" classes={["width70"]} attributes={{ min: 0, value: number || "" }} placeHolder="Numero de telefono" onChange={numberChange} />
                </Stack>
            </Box>
        </Fragment>
    );
}

const Main = ({ dimensions, path, state }) => {

    // COMPONENT STATES
    const dispatch = useDispatch();

    const handleNumberChange = (e) => {
        let error = !(/([0-9])+ ([0-9]){6,}/g).test(`${state.extension} ${state.number}`);
        dispatch(setPhone({ number: e, extension: state.extension, error }));
    }
    const handleExtensionChange = (e) => {
        let error = !(/\+([0-9])+ ([0-9]){6,}/g).test(`${state.extension} ${state.number}`);
        dispatch(setPhone({ number: state.number, extension: e, error }));
    }

    // UPDATE USER'S PHONE NUMBER
    const updatePhone = async () => await dispatch(updateUserPhoneNumber())
        .unwrap()
        .then(({ response }) => {
            if (response?.ok) return true;
            else return false;
        })
        .catch(() => false);

    return (
        <Fragment>
            {/* PHONE NUMBER COMPONENT */}
            {path === "phone" && <NumberComponent
                ext={state.extension}
                number={state.number}
                numberChange={({ target }) => handleNumberChange(target.value)}
                extensionChange={({ target }) => handleExtensionChange(target.value)}
            />}

            {/* CONTROLLER */}
            <ScreenControl
                disabled={state.error}
                beforeSubmit={() => updatePhone()}
            />
        </Fragment>
    );
}

export const OneshotConfirmationPhone = ({ dimensions, path }) => {

    // Memoized Selectors (Avoid Re renders)
    const getPhone = (state) => state.phone;
    const getOneshot = (state) => state.oneshot;
    const initState = createSelector([getPhone, getOneshot], (phone, oneshot) => ({ phone, oneshot }))
    // Retrieve state whit Memoized Selectors
    const state = useSelector(({ user }) => initState(user));

    if (!state.oneshot) return <Main dimensions={dimensions} path={path} state={state.phone} />;
    else return (
        <>
            <Box classes={["marginTB1em"]}>

                <Stack style={{ margin: "1em 0 2em 0" }} flex={{
                    alignItems: "center",
                    justifyContent: "center",
                }}>
                    <Box
                        superStyle={{ width: "auto" }}
                        classes={["glowingCircularBadge"]}
                        extraClasses="main-div main-div2"
                    >
                        <Fingerprint style={{ fontSize: "10em", color: "#E2E5F0" }}></Fingerprint>
                    </Box>
                </Stack>
                <Text classes={["titleMediumMargin", "center"]}> Firma registrada </Text>
                <Text classes={["subtitle", "center"]}> Ya has firmado el contrato. </Text>
                <Text classes={["subtitle", "center"]}> Puedes continuar con tu registro. </Text>
            </Box>
            <ScreenControl disabled={false} />
        </>
    );
}